/**
 * Dialog résultat SMS devis (extrait de OrDetail.jsx — iter31).
 *
 * Affiche le statut d'envoi (réel Twilio ou mocké) et le lien public de validation
 * que le client recevra par SMS. Boutons copier / ouvrir.
 */
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send, Copy, Link2 } from "lucide-react";

export default function OrSmsResultDialog({ open, onClose, smsResult, onCopyLink }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="sms-result-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send className="w-5 h-5 text-[#0891b2]" />
            {smsResult?.mocked ? "Lien généré (SMS mocké)" : "SMS envoyé au client"}
          </DialogTitle>
        </DialogHeader>
        {smsResult?.mocked && (
          <div className="bg-amber-50 border border-amber-200 rounded-md p-3 text-xs text-amber-900">
            <strong>⚠️ Mode mock :</strong> Twilio n'est pas configuré, aucun SMS réel n'a été envoyé.
            Vous pouvez copier le lien ci-dessous et l'envoyer manuellement, ou configurer Twilio
            dans <code>backend/.env</code>.
          </div>
        )}
        {!smsResult?.mocked && (
          <div className="bg-green-50 border border-green-200 rounded-md p-3 text-xs text-green-900">
            <strong>✅ SMS expédié</strong> à <span className="font-mono">{smsResult?.to}</span>.
            Le statut de l'OR a été mis à jour en « Devis envoyé ».
          </div>
        )}
        <div className="space-y-2">
          <div className="text-xs uppercase tracking-wider text-gray-500 font-semibold">
            Lien public de validation
          </div>
          <div className="flex gap-2">
            <Input
              value={smsResult?.url || ""}
              readOnly
              className="font-mono text-xs"
              onFocus={(e) => e.target.select()}
              data-testid="sms-result-url"
            />
            <Button size="icon" variant="outline" onClick={onCopyLink} data-testid="sms-copy-link">
              <Copy className="w-4 h-4" />
            </Button>
            <Button
              size="icon"
              variant="outline"
              onClick={() => window.open(smsResult?.url, "_blank", "noopener")}
              data-testid="sms-open-link"
            >
              <Link2 className="w-4 h-4" />
            </Button>
          </div>
          <p className="text-xs text-gray-500">
            Le client recevra ce lien par SMS et pourra accepter ou refuser le devis directement
            depuis son téléphone. Le lien expire dans 30 jours.
          </p>
        </div>
        <DialogFooter>
          <Button
            onClick={onClose}
            className="bg-[#52a675] hover:bg-[#3d8a5c]"
            data-testid="sms-dialog-close"
          >
            Compris
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
